// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2DklY","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__5JJH2"};